import { createApp } from "vue";
import App from "./App.vue";
import router from "./router/main"; // Main website router
import store from "./store";
import axios from "axios";
import logger, { createLogger } from "./utils/logger";
import urlHelper from "./utils/URLHelper";

// Bootstrap CSS and Icons
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap-icons/font/bootstrap-icons.css";

// Bootstrap JS
import { Tooltip, Toast, Popover } from "bootstrap";
import * as bootstrap from "bootstrap";

// Animate.css and scroll animation
import "animate.css";
import scrollanimation from "./v-scrollanimation";

// SweetAlert2
import Swal from "sweetalert2";

// Custom CSS
import "./assets/css/style.css";

// Configure axios for cookie-based authentication
axios.defaults.withCredentials = true;
axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL;

const app = createApp(App);

// Global properties
app.config.globalProperties.$swal = Swal;
app.config.globalProperties.$tooltip = Tooltip;
app.config.globalProperties.$toast = Toast;
app.config.globalProperties.$popover = Popover;
app.config.globalProperties.$bootstrap = bootstrap;

// Add logger as a global property
app.config.globalProperties.$logger = logger;
app.config.globalProperties.$createLogger = createLogger;

// Add URL helper for cross-subdomain navigation
app.config.globalProperties.$urlHelper = urlHelper;

// Configure for main website
app.config.globalProperties.$module = "main";

// Set loading to false for main website since it doesn't require authentication
store.commit("setLoading", false);
store.commit("setAuthChecked", true);

// Setup Axios interceptor for token refresh on 401 (fallback support)
axios.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;

    // Skip interception for refresh requests or retries
    if (
      !originalRequest ||
      originalRequest._retry ||
      originalRequest.url?.includes("/refresh")
    ) {
      return Promise.reject(error);
    }

    // On 401, try to refresh if authenticated
    if (error.response?.status === 401) {
      if (store.getters.isAuthenticated || store.getters.isStaffAuthenticated) {
        originalRequest._retry = true;

        try {
          await store.dispatch("refreshAccessToken");
          const newAccessToken = store.state.accessToken;

          if (newAccessToken) {
            originalRequest.headers.Authorization = `Bearer ${newAccessToken}`;
            return axios(originalRequest);
          }
        } catch (refreshError) {
          logger.error("Token refresh failed");
          return Promise.reject(refreshError);
        }
      }
    }

    return Promise.reject(error);
  }
);

app
  .use(store)
  .use(router)
  .directive("scrollanimation", scrollanimation)
  .mount("#app");
